<div class="example-container">
  <form
    fxLayout="column"
    [formGroup]="loginForm"
    #form="ngForm"
    (ngSubmit)="submit(form)"
  >
    <!-- Email Input -->
    <mat-form-field appearance="fill">
      <mat-label>Enter your username</mat-label>
      <input
        matInput
        placeholder="username"
        name="username"
        formControlName="username"
        required
      />
      <mat-error *ngIf="loginForm.invalid">{{ getErrorMessage() }}</mat-error>
    </mat-form-field>

    <!-- Password Input -->
    <mat-form-field appearance="fill">
      <mat-label>Enter your password</mat-label>
      <input
        matInput
        name="password"
        formControlName="password"
        [type]="hide ? 'password' : 'text'"
        required
      />
      <!-- <button mat-icon-button matSuffix (click)="hide = !hide" [attr.aria-label]="'Hide password'"
        [attr.aria-pressed]="hide">
        <mat-icon>{{ hide ? "visibility_off" : "visibility" }}</mat-icon>
      </button> -->
    </mat-form-field>

    <mat-error *ngIf="showError">{{ errorMessage }}</mat-error>

    <!-- Submit Button -->
    <div class="submit-button-div">
      <button
        [style.backgroundColor]="env['colors']['primary']"
        class="submitButton"
        type="submit"
        (keydown.enter)="submit(form)"
        [disabled]="!form.valid"
        mat-raised-button
      >
        Log into PAM Lab Dashboard
      </button>
    </div>
  </form>
</div>
